import axios from 'axios';
import { KEYCLOAK_ENDPOINTS } from '../config/endpoints';
import env from '../config/env';

const authClient = axios.create({
  baseURL: KEYCLOAK_ENDPOINTS.TOKEN,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
  },
});

export const login = async (username, password) => {
  const params = new URLSearchParams();
  params.append('grant_type', 'password');
  params.append('client_id', env.KEYCLOAK_CLIENT_ID);
  params.append('scope', env.KEYCLOAK_SCOPE);
  params.append('username', username);
  params.append('password', password);

  const response = await authClient.post('', params);
  return response.data;
};

export const refreshAccessToken = async (refreshTokenValue) => {
  const params = new URLSearchParams();
  params.append('grant_type', 'refresh_token');
  params.append('client_id', env.KEYCLOAK_CLIENT_ID);
  params.append('refresh_token', refreshTokenValue);

  const response = await authClient.post('', params);
  return response.data;
};

export const keycloakLogout = async (refreshTokenValue) => {
  const params = new URLSearchParams();
  params.append('client_id', env.KEYCLOAK_CLIENT_ID);
  params.append('refresh_token', refreshTokenValue);

  await axios.post(KEYCLOAK_ENDPOINTS.LOGOUT, params, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
  });
};

export default authClient;
